<template>
  <div>
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>

export default {
  name: 'CustomerContainer',
  beforeMount() {
    if (this.$route.name === 'CustomerContainer') {
      this.$router.replace({name: 'Customers' });
    }
  }
}
</script>
